module.exports = __webpack_public_path__ + "img/full5-min.8873d4fa.png";